module.exports = __webpack_public_path__ + "media/images/fedex_logo-eaae8e56ef9023b33ae19ada5e3b4ee3.png";